/* eslint-disable no-unused-vars */
import {
  useElement,
  useState,
  useStaleLayout,
  useRect,
  useEffect,
  useModel,
} from '@nebula.js/stardust';
import picassojs from 'picasso.js';
import numeral from 'numeral';
import picassoQ from 'picasso-plugin-q';
import picassoHammer from 'picasso-plugin-hammer';
import * as d3 from 'd3';

export default function supernova() {
  const picasso = picassojs();
  picasso.use(picassoQ);
  picasso.use(picassoHammer);

  return {
    qae: {
      properties: {
        qHyperCubeDef: {
          qDimensions: [],
          qMeasures: [],
          qInitialDataFetch: [{ qWidth: 2, qHeight: 5000 }],
          qSuppressZero: false,
          qSuppressMissing: true,
        },
        showTitles: true,
        title: '',
        subtitle: '',
        footnote: '',
      },
      data: {
        targets: [
          {
            path: '/qHyperCubeDef',
            dimensions: {
              min: 1,
              max: 1,
            },
            measures: {
              min: 1,
              max: 1,
            },
          },
        ],
      },
    },
    component() {
      const element = useElement();
      const layout = useStaleLayout();
      const rect = useRect();
      const model = useModel();

      const [instance, setInstance] = useState();

      useEffect(() => {
        const p = picasso.chart({
          element,
          data: [],
          settings: {},
        });

        setInstance(p);

        return () => {
          p.destroy();
        };
      }, []);

      useEffect(() => {
        if (!instance) {
          return;
        }

        // const colorScale = d3.scaleOrdinal()
        //   .domain(['White', 'Unknown', 'Asian', 'Indigenous', 'Mixed Race', 'Black', 'Middle Eastern', 'Latin'])
        //   .range(['#A7A4D4', '#A55886', '#C17A82', '#408CA0', '#6BE0DD', '#A55886', '#E8CEAA', '#A2C3B4']);

        const doPercent = layout.qHyperCube.qMeasureInfo[0].qFallbackTitle !== 'Count(Distinct respid)';

        instance.update({
          data: [
            {
              type: 'q',
              key: 'qHyperCube',
              data: layout.qHyperCube,
            },
          ],
          settings: {
            formatters: {
              percent: {
                formatter: 'd3',
                type: 'number',
                format: ',.0%',
              },
            },
            scales: {
              y: {
                data: {
                  field: 'qMeasureInfo/0',
                },
                invert: false,
                expand: 0.15,
                min: 0,
                // include: [0, 1],
              },
              color: {
                data: {
                  extract: {
                    field: 'qMeasureInfo/0',
                  },
                },
                range: ['#655dc6',
                '#1c355e',
                '#006580',
                '#009845',
                '#870064',
                '#27b9ed',
                '#244b5a'],
                type: 'color',
              },
              x: {
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                  },
                },
                invert: true,
                paddingInner: 0.1,
              },
            },
            components: [
              {
                type: 'axis',
                dock: 'left',
                scale: 'x',
                settings: {
                  labels: {
                    show: true,
                    fontSize: 10.5,
                  },
                },
              },
              {
                type: 'axis',
                dock: 'bottom',
                scale: 'y',
                formatter: doPercent ? 'percent' : '',
              },
              {
                key: 'bars',
                type: 'box',
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                    props: {
                      start: 0,
                      end: { field: 'qMeasureInfo/0' },
                    },
                  },
                },
                settings: {
                  orientation: 'horizontal',
                  major: { scale: 'x' },
                  minor: { scale: 'y' },
                  box: {
                    // fill: (d) => {
                    //   if (selectedRace.length) {
                    //     if (selectedRace.includes(d.datum.label)) {
                    //       return colorScale(d.datum.label);
                    //     }
                    //     return '#D3D3D3';
                    //   }
                    //   return colorScale(d.datum.label);
                    // },
                    fill: '#655dc6',

                  },
                },
              },
              {
                type: 'grid-line',
                x: {
                  scale: 'y',
                },
                ticks: {
                  show: true,
                  stroke: '#70707030',
                  strokeWidth: 1,
                  // strokeDasharray: '3, 3',
                },
               },
              {
                type: 'labels',
                displayOrder: 2,
                settings: {
                  sources: [{
                    component: 'bars',
                    selector: 'rect',
                    strategy: {
                      type: 'bar',
                      settings: {
                        direction: 'right',
                        labels: [{
                          placements: [{
                            position: 'outside',
                          }],
                          label: (node) => (doPercent ? numeral(node.data.end.value).format('0.0%') : node.data.end.value),
                        }],
                        fontSize: 10,
                      },
                    },
                  }],
                },
              },
            ],
            interactions: [
              // {
              //   type: 'native',
              //   events: {
              //     mousemove(e) {
              //       this.chart.component('tooltip').emit('show', e);
              //     },
              //     mouseleave() {
              //       this.chart.component('tooltip').emit('hide');
              //     },
              //   },
              // },
              {
                type: 'hammer',
                gestures: [
                  {
                    type: 'Tap',
                    events: {
                      tap(e) {
                        const chartBounds = element.getBoundingClientRect();
                        const cx = e.center.x - chartBounds.left;
                        const cy = e.center.y - chartBounds.top;
                        const shapes = this.chart.shapesAt({ x: cx, y: cy });
                        const values = shapes.map((shape) => shape.data.value);
                        model.selectHyperCubeValues('/qHyperCubeDef', 0, values, true);
                      },
                    },
                  },
                ],
              },

              // {
              //   type: 'native',
              //   events: {
              //     // click(e) {
              //     //   const chartBounds = element.getBoundingClientRect();
              //     //   const cx = e.clientX - chartBounds.left;
              //     //   const cy = e.clientY - chartBounds.top;
              //     //   const shapes = this.chart.shapesAt({ x: cx, y: cy });
              //     //   const values = shapes.map((shape) => shape.data.value);
              //     //   model.selectHyperCubeValues('/qHyperCubeDef', 0, values, true);
              //     // },
              //   },
              // },
              // {
              //   type: 'hammer',
              //   gestures: [
              //     {
              //       type: 'Tap',
              //       events: {
              //         tap(e) {
              //           const chartBounds = element.getBoundingClientRect();
              //           const cx = e.center.x - chartBounds.left;
              //           const cy = e.center.y - chartBounds.top;
              //           const shapes = this.chart.shapesAt({ x: cx, y: cy });
              //           const values = shapes.map((shape) => shape.data.value);
              //           model.selectHyperCubeValues('/qHyperCubeDef', 0, values, true);
              //         },
              //       },
              //     },
              //   ],
              // },
            ],
          },
        });
      }, [layout, instance]);

      useEffect(() => {
        if (!instance) {
          return;
        }
        instance.update();
      }, [rect.width, rect.height, instance]);
    },
  };
}
